import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormFields } from '../../AccountForm.meta';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';

export const AnnuitizationDistributionDuration = () => {
  const { control } = useFormContext<FormFields>();

  return (
    <Controller
      control={control}
      name="bankAccount.AnnuitizationDistributionDuration"
      render={({ field: { onChange, ...field } }) => (
        <InputNumberMask
          {...field}
          label="Period Duration"
          thousandSeparator={false}
          decimalScale={0}
          allowNegative={false}
          onValueChange={({ floatValue }) => {
            onChange(floatValue ?? null);
          }}
        />
      )}
    />
  );
};
